import { createContext, useEffect, useState } from "react";

export const AuthContext = createContext({
  state: undefined,
  dispatch: undefined,
  token: undefined,
  setToken: undefined,
  direction: undefined,
  setDirection: undefined,
  coberturas: undefined,
  setCoberturas: undefined,
  persons: undefined,
  setPersons: undefined,
  confirmData: undefined,
  setConfirmData: undefined,
  timer: undefined,
  setTimer: undefined,
  message: undefined,
  setSnackData: undefined,
  showMessage: undefined,
  setSnackMessage: undefined,
  firstLoad: undefined,
  setFirstLoad: undefined,
  isInterno: undefined,
  setIsInterno: undefined,
  setSections21: undefined,
  sections21: undefined,
  typeEnd: undefined,
  categorias902: undefined,
  setCategorias902: undefined,
  handleContinuer: undefined,
  setHandleContinue: undefined,
  showContinue: undefined,
  setShowContinue: undefined,
  showBack: undefined,
  setShowBack: undefined,
  onlyApprove: undefined,
  setOnlyApprove: undefined,
  backupSuplement: undefined,
  setBackupSuplement: undefined,
  bajaAseguramiento: undefined,
  setBajaAseguramiento: undefined,
});

export const ContextProvider = ({ children }) => {
  const [holder, setHolder] = useState({ amount: 0 });
  const [firstLoad, setFirstLoad] = useState(true);
  const [state, dispatch] = useState();
  const [direction, setDirection] = useState({});
  const [coberturas, setCoberturas] = useState({});
  const [persons, setPersons] = useState([]);
  const [confirmData, setConfirmData] = useState({});
  const [timer, setTimer] = useState(0);
  const [showMessage, setSnackMessage] = useState(false);
  const [message, setSnackData] = useState({});
  const [sections21, setSections21] = useState([]);
  const [showContinue, setShowContinue] = useState(false);
  const [categorias902, setCategorias902] = useState([]);
  const [handleContinue, setHandleContinue] = useState(false);
  const [token, setToken] = useState(
    localStorage.getItem("token")
      ? JSON.parse(localStorage.getItem("token"))
      : {}
  );
  const [isInterno, setIsInterno] = useState();
  const [typeEnd, setTypeEnd] = useState();
  const [showBack, setShowBack] = useState(true);
  const { pathname } = window.location;
  const [onlyApprove, setOnlyApprove] = useState([]);
  const [backupSuplement, setBackupSuplement] = useState(0);
  const [bajaAseguramiento, setBajaAseguramiento] = useState(null);

  useEffect(() => {
    if (pathname !== "/endoso") {
      setShowBack(true);
    }
  }, [pathname]);

  return (
    <AuthContext.Provider
      value={{
        state,
        dispatch,
        token,
        setToken,
        direction,
        setDirection,
        coberturas,
        setCoberturas,
        persons,
        setPersons,
        confirmData,
        setConfirmData,
        timer,
        setTimer,
        message,
        setSnackData,
        showMessage,
        setSnackMessage,
        firstLoad,
        setFirstLoad,
        isInterno,
        setIsInterno,
        setSections21,
        sections21,
        typeEnd,
        setTypeEnd,
        categorias902,
        setCategorias902,
        handleContinue,
        setHandleContinue,
        showContinue,
        setShowContinue,
        showBack,
        setShowBack,
        onlyApprove,
        setOnlyApprove,
        backupSuplement,
        setBackupSuplement,
        bajaAseguramiento,
        setBajaAseguramiento,
        holder,
        setHolder,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};
